export const osnArrowPlayerRightIcon = {
  // eslint-disable-next-line max-len
  data: `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M31.4516 11L37.2458 17.3131C38.2514 18.4089 38.2514 20.1854 37.2458 21.2811C37.2101 21.3199 37.1734 21.3576 37.1357 21.3942L31.4516 26.8993M37.0645 19.2302H17.8871C12.9789 19.2302 9 23.2081 9 28.1151C9 33.0221 12.9789 37 17.8871 37H27.7631" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>`,
  name: 'arrow-player-right',
};
